/**
 * El precio que cobró la Caja, pegado a cada línea de una venta SIN INTERNET.
 *
 * Al volver la señal, el servidor registra la venta a ESTE precio aunque el
 * catálogo haya cambiado mientras tanto (decisión del dueño: se respeta lo
 * cobrado), y apunta el del catálogo si no coincide. Ver `create_sale`.
 *
 * ⚠️ Solo para la cola sin internet. En una venta con internet el precio lo
 * pone el servidor: mandarlo ahí sería dejar que el navegador lo decida.
 *
 * `items` sale de `lineas` en el mismo orden (ver `ModalPago`), así que la
 * línea i es la i.
 */

import { precioDeLinea, type LineaCarrito } from "@/stores/carrito";

export function conElPrecioCobrado<T extends object>(
  items: T[],
  lineas: readonly Pick<LineaCarrito, "precioBase" | "preciosPorLista" | "opciones">[],
  listaPreciosId: string | null,
): (T & { unit_price?: string })[] {
  return items.map((it, i) => {
    const linea = lineas[i];
    return linea ? { ...it, unit_price: String(precioDeLinea(linea, listaPreciosId)) } : it;
  });
}
